// Preloader
export function sitePreloader() {
    const preloader = document.querySelector('#site-preloader');

    if (!preloader) {
        return;
    }

    if (preloader.classList.contains('loaded')) {
        preloader.classList.remove('loaded');
    }
    setTimeout(function () {
        preloader.classList.add('loaded');
    }, 600);
}
